import { getInitialWidgetPosition } from 'modules/Editor/Editor.helpers';
import { ImageMetadata } from 'types/imageLibsTypes';
import { generateDefaultData as generateImageData } from 'widgets/ImageWidget/ImageWidget.helpers';

import { GUTTER_SIZE, THUMBNAIL_WIDTH } from '../InfiniteGrid/InfiniteGrid.config';

/**
 * A function required by the react-window to calculate a width of each column.
 * In out current use case, we just need to return a const number.
 *
 * @returns a number
 */
export const calculateColumnWidth = () => {
  return THUMBNAIL_WIDTH + GUTTER_SIZE;
};

/**
 * A helper function for generating widgetData for Photo widget from ImageMetadata
 *
 * @returns widgetData
 */
export const createPhotoWidgetData = (hit: ImageMetadata) => {
  const { top, left, infographWidth, infographHeight } = getInitialWidgetPosition();
  if (!hit.webformatURL) {
    return generateImageData(
      hit.url, // image url
      { width: hit.imageWidth, height: hit.imageHeight }, //image size
      { width: infographWidth, height: infographHeight }, // infograph size
      top,
      left,
    );
  }
  return {
    ...generateImageData(
      hit.webformatURL, // image url
      { width: hit.imageWidth, height: hit.imageHeight }, //image size
      { width: infographWidth, height: infographHeight }, // infograph size
      top,
      left,
    ),
    ...{ shouldCache: true },
  };
};
